import { formatForm } from './form';

export const form = {
  create: () => ({
    method: 'POST',
    url: '{{backendUrl}}/FormService/Form/CreateTemplate',
    parse: 'parseForm',
  }),
  get: (formId) => ({
    method: 'GET',
    url: `{{backendUrl}}/FormService/Form/${formId}/GetTemplate`,
    parse: 'parseForm',
  }),
  update: (values) => ({
    method: 'PUT',
    url: '{{backendUrl}}/FormService/Form/UpdateTemplate',
    parse: 'parseForm',
    json: formatForm(values),
  }),
};

export const task = {
  getTask: (projectId, isReview) => ({
    method: 'POST',
    url: '{{backendUrl}}/TaskService/Hit',
    parse: 'parseTask',
    json: {
      IdProject: projectId,
      isReview,
    },
  }),
  getForm: (formId) => ({
    method: 'GET',
    url: `{{backendUrl}}/FormService/Form/${formId}/GetTemplate`,
    parse: 'parseForm',
  }),
  createAnswer: (taskId, supportDateTime, duration, answer) => ({
    method: 'PUT',
    url: '{{backendUrl}}/TaskService/Hit',
    json: {
      IdHit: taskId,
      SupportDateTime: supportDateTime,
      Duration: duration,
      Answer: answer,
    },
  }),
  release: (taskId) => ({
    method: 'DELETE',
    url: `{{backendUrl}}/TaskService/Hit/${taskId}`,
  }),
  // Confirmé dans le code source (Task.Api/Controllers/HitController.cs) : ce PATCH déclare
  // [FromBody] UserInfoDto mais ne l'utilise jamais (l'utilisateur vient des revendications du
  // jeton), et le contrôleur n'a pas l'attribut [ApiController] — qui est ce qui rendrait un
  // [FromBody] obligatoire par défaut sur ASP.NET Core. Une requête sans corps est donc liée à
  // null et acceptée normalement. Pas de corps nécessaire.
  keep: (taskId) => ({
    method: 'PATCH',
    url: `{{backendUrl}}/TaskService/Hit/${taskId}`,
  }),
};

/*
 * Read-only: reads an answer that was already recorded, one URL per kind of answer.
 * `answerOf` is set by the routes in App.jsx.
 */
export const answer = {
  get: (answerOf, params) => {
    switch (answerOf) {
      case 'taskLine':
        return {
          method: 'GET',
          url: `{{backendUrl}}/TaskService/Task/${params.taskLineId}/GetTask`,
          parse: 'parseAnswer',
        };
      case 'certification':
        return {
          method: 'GET',
          // eslint-disable-next-line @stylistic/max-len
          url: `{{backendUrl}}/CertificationService/CertificationUserTest/${params.certificationUserTestId}/Questions/${params.questionId}`,
          parse: 'parseAnswerCertification',
        };
      case 'task':
      default:
        // The route param carries a "taskId", which is in fact a hitId here
        return {
          method: 'GET',
          url: `{{backendUrl}}/TaskService/Hit/${params.taskId}`,
          parse: 'parseAnswerHit',
        };
    }
  },
};

/*
 * The v5 backend splits certifications in two resources, and the URLs below follow it:
 *   CertificationUserTest - the test instance taken by a candidate (their own questions
 *                           and their own answers)
 *   Certification         - the questions referential, holding the reference answers
 */
export const certification = {
  // Candidate's test: next question to answer
  get: (certificationId) => ({
    method: 'POST',
    url: `{{backendUrl}}/CertificationService/CertificationUserTest/${certificationId}/Question`,
    parse: 'parseCertification',
  }),
  getForm: (formId) => ({
    method: 'GET',
    url: `{{backendUrl}}/FormService/Form/${formId}/GetTemplate`,
    parse: 'parseForm',
  }),
  // Candidate's test: submits the candidate's own answer.
  // The fourth argument certificationUserQuestionId is v3 only
  createAnswer: (certificationId, certificationUserId, certificationQuestionId, _, answer) => ({
    method: 'PUT',
    url: '{{backendUrl}}/CertificationService/CertificationUserTest/SubmitQuestion',
    json: {
      IdCertification: certificationId,
      IdCertificationUserTest: certificationUserId,
      IdCertificationQuestion: certificationQuestionId,
      Answer: answer,
    },
  }),
  // Manager publish flow: one referential question, to define its reference answer
  getQuestion: (certificationId, questionId) => ({
    method: 'GET',
    // eslint-disable-next-line @stylistic/max-len
    url: `{{backendUrl}}/CertificationService/Certification/${certificationId}/Question/${questionId}`,
    parse: 'parseCertificationQuestion',
  }),
  // Manager publish flow: saves the reference answer of a referential question
  updateQuestionAnswer: (certificationId, questionId, jsonAnswer) => ({
    method: 'PUT',
    url: '{{backendUrl}}/CertificationService/Certification/Questions/UpdateAnswer',
    json: {
      IdCertification: certificationId,
      IdCertificationQuestion: questionId,
      Answer: jsonAnswer,
    },
  }),
};
